import { API_BASE } from './config'
import { getAuthHeaders } from './api'
import type { DmThreadList, DmThreadDetail, DmOpenResult } from '@/types/social'

interface RequestInit {
  method?: string
  body?: string
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    method: init?.method,
    body: init?.body,
    headers: {
      ...getAuthHeaders(),
      ...(init?.body ? { 'Content-Type': 'application/json' } : {})
    }
  })
  const result = await response.json().catch(() => null) as { success: boolean; data?: T; error?: { message?: string } } | null
  if (!response.ok || !result?.success || result.data === undefined) {
    throw new Error(result?.error?.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.')
  }
  return result.data
}

export const messagesService = {
  fetchThreads: (): Promise<DmThreadList> =>
    call('/users/me/messages/threads'),

  fetchThread: (threadId: number, afterId = 0): Promise<DmThreadDetail> =>
    call(`/users/me/messages/threads/${threadId}?after_id=${afterId}`),

  send: (threadId: number, content: string): Promise<{ id: number; thread_id: number }> =>
    call(`/users/me/messages/threads/${threadId}`, {
      method: 'POST',
      body: JSON.stringify({ content })
    }),

  markRead: (threadId: number): Promise<{ thread_id: number }> =>
    call(`/users/me/messages/threads/${threadId}/read`, { method: 'POST' }),

  openThread: (username: string): Promise<DmOpenResult> =>
    call('/users/me/messages/threads', {
      method: 'POST',
      body: JSON.stringify({ username })
    }),

  unreadCount: (): Promise<{ unread: number }> =>
    call('/users/me/messages/unread-count')
}
